var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-stream-node"},[_c('streaming-markdown',{attrs:{"content":_vm.chunks,"streaming":_vm.status === 'streaming'}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }